module.exports = __webpack_public_path__ + "static/media/franchisebanner.66fbcad8.png";